export function getDocumentTitle(appTitle: string): string {
  return `Ipsos - ${appTitle}`;
}
